import type { WidgetPublicState } from "@/types";
import type { StateSlice, SliceCreator } from "@/state";

export const initialPublicState: WidgetPublicState = {
  ready: false,
  loggedIn: false,
  env: "prod",
  clientId: "",
  user: null,
  // Script `data-avatarUrl` / `data-avatarWidth` (logged-out override) temporarily disabled:
  avatarUrl: undefined,
  avatarWidth: undefined,
  language: "el",
  urls: { loginUrl: "", logouturl: "", profileUrl: "", authHost: "" },
};

export const createStateSlice: SliceCreator<StateSlice> = (set) => ({
  state: initialPublicState,

  setState: (patch) =>
    set((s) => ({ state: { ...s.state, ...patch } }), false, "state/setState"),

  resetState: () =>
    set(() => ({ state: initialPublicState }), false, "state/resetState"),
});
